var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectExpenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 43.621 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(-28.102 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4697",
    "data-name": "Group 4697",
    transform: "translate(28.102 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4696",
    "data-name": "Group 4696",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M94.323,256.45h-9.65a.718.718,0,1,0,0,1.436h9.65a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-78.611 -231.907)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M94.323,321.864h-9.65a.718.718,0,1,0,0,1.436h9.65a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-78.611 -291.061)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M94.323,387.279h-9.65a.718.718,0,1,0,0,1.436h9.65a.718.718,0,1,0,0-1.436Z",
    transform: "translate(-78.611 -350.215)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6015",
    "data-name": "Path 6015",
    d: "M269.614,298.957h1.523a.718.718,0,0,0,0-1.436h-1.523a.718.718,0,0,0,0,1.436Z",
    transform: "translate(-245.851 -269.047)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6016",
    "data-name": "Path 6016",
    d: "M319.493,297.521H317.97a.718.718,0,0,0,0,1.436h1.523a.718.718,0,1,0,0-1.436Z",
    transform: "translate(-289.579 -269.047)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6017",
    "data-name": "Path 6017",
    d: "M367.848,297.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-333.307 -269.047)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6018",
    "data-name": "Path 6018",
    d: "M416.205,297.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-377.036 -269.047)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6019",
    "data-name": "Path 6019",
    d: "M269.614,337.957h1.523a.718.718,0,0,0,0-1.436h-1.523a.718.718,0,0,0,0,1.436Z",
    transform: "translate(-245.851 -304.315)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M319.493,336.521H317.97a.718.718,0,0,0,0,1.436h1.523a.718.718,0,1,0,0-1.436Z",
    transform: "translate(-289.579 -304.315)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6021",
    "data-name": "Path 6021",
    d: "M367.848,336.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-333.307 -304.315)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M416.205,336.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-377.036 -304.315)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M269.614,376.957h1.523a.718.718,0,0,0,0-1.436h-1.523a.718.718,0,0,0,0,1.436Z",
    transform: "translate(-245.851 -339.582)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M319.493,375.521H317.97a.718.718,0,0,0,0,1.436h1.523a.718.718,0,1,0,0-1.436Z",
    transform: "translate(-289.579 -339.582)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    "data-name": "Path 6025",
    d: "M367.848,375.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-333.307 -339.582)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    "data-name": "Path 6026",
    d: "M416.205,375.521h-1.523a.718.718,0,0,0,0,1.436h1.523a.718.718,0,0,0,0-1.436Z",
    transform: "translate(-377.036 -339.582)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    "data-name": "Path 6027",
    d: "M97.5,65.06a.718.718,0,1,0-.786,1.2,4.8,4.8,0,0,0,2.7.921v.966a.718.718,0,1,0,1.436,0v-1.02a3.877,3.877,0,0,0,3.119-3.2,3.4,3.4,0,0,0-2.34-3.888c-.28-.1-.539-.194-.779-.286V55.745a2.593,2.593,0,0,1,1.15.524.718.718,0,0,0,.969-1.059,4.1,4.1,0,0,0-2.119-.918v-.864a.718.718,0,1,0-1.436,0v.92q-.212.043-.434.11a3.21,3.21,0,0,0-2.2,2.519,2.815,2.815,0,0,0,.918,2.775,7.859,7.859,0,0,0,1.713.974v5.023A3.4,3.4,0,0,1,97.5,65.06Zm3.351-3.769.3.107a1.981,1.981,0,0,1,1.4,2.3,2.468,2.468,0,0,1-1.7,1.959ZM98.591,58.62a1.4,1.4,0,0,1-.393-1.379,1.791,1.791,0,0,1,1.2-1.41l.02-.005v3.31A5.184,5.184,0,0,1,98.591,58.62Z",
    transform: "translate(-89.857 -47.665)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6028",
    "data-name": "Path 6028",
    d: "M65.7,44.776a.718.718,0,0,0-.718.718v.513a1.559,1.559,0,0,1-1.557,1.557H31.095a1.559,1.559,0,0,1-1.557-1.557V2.993a1.559,1.559,0,0,1,1.557-1.557H56.208a1.553,1.553,0,0,1,.225.018v6a2.533,2.533,0,0,0,2.53,2.53h6a1.552,1.552,0,0,1,.018.225v3.427a.718.718,0,0,0,1.436,0V10.21a3.123,3.123,0,0,0-.861-2.1L58.325.877,58.308.86l0,0h0L58.3.853A3,3,0,0,0,56.208,0H31.095A3,3,0,0,0,28.1,2.993V46.007A3,3,0,0,0,31.095,49H63.426a3,3,0,0,0,2.993-2.993v-.513A.718.718,0,0,0,65.7,44.776ZM57.869,2.451l6.1,6.1H58.963a1.1,1.1,0,0,1-1.094-1.094v-5Z",
    transform: "translate(-28.102 0)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M251.7,170.178H232.371a2.5,2.5,0,0,0-2.492,2.492v2.415a.718.718,0,0,0,1.436,0V172.67a1.058,1.058,0,0,1,1.056-1.056H251.7a1.057,1.057,0,0,1,1.056,1.056v21.59a1.057,1.057,0,0,1-1.056,1.056H232.371a1.057,1.057,0,0,1-1.056-1.056V178.44a.718.718,0,0,0-1.436,0v15.82a2.5,2.5,0,0,0,2.492,2.492H251.7a2.5,2.5,0,0,0,2.492-2.492V172.67A2.5,2.5,0,0,0,251.7,170.178Z",
    transform: "translate(-210.568 -153.891)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M285.738,207.8a1.271,1.271,0,0,0-1.27-1.27h-14.3a1.271,1.271,0,0,0-1.27,1.27v3.673a1.271,1.271,0,0,0,1.27,1.27h14.3a1.271,1.271,0,0,0,1.27-1.27Zm-1.436,3.508H270.332v-3.342H284.3v3.342Z",
    transform: "translate(-245.851 -186.764)",
    fill: "#f48116"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectExpenses);
export default __webpack_public_path__ + "static/media/ProjectExpenses.ae4b1c52f8939138dc2b26d589996e31.svg";
export { ForwardRef as ReactComponent };